import gql from "graphql-tag";

export const VIEW_PROFILE = gql`
  query userWithBusinessProfile {
    users {
      id
      full_name
      email
      mobile_number
      is_profile_setup
      business_profile {
        id
        abn
        location_text
        location
        business_cover_path
        business_cover_photo
        business_profile_path
        business_profile_photo
        description
        name
        email
        mobile_number
        website
        opening_hours
        created_at
        categories
      }
      club_profile {
       id
       abn
       location_text
       location
       cover_path
       cover_photo
       profile_path
       profile_photo
       description
       name
       email
       mobile_number
       website
       opening_hours
       created_at
       categories
     }
    }
  }
`;
